'use client';
import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import { CATEGORIES } from '@/lib/roastData';
import { submissionService } from '@/lib/services/submissionService';
import { Flame, Upload, CheckCircle, X, Image, Type, Globe, Tag, FileText, Loader2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const COUNTRIES = [
  { name: 'Afghanistan', flag: '🇦🇫' },
  { name: 'Albania', flag: '🇦🇱' },
  { name: 'Algeria', flag: '🇩🇿' },
  { name: 'Andorra', flag: '🇦🇩' },
  { name: 'Angola', flag: '🇦🇴' },
  { name: 'Antigua and Barbuda', flag: '🇦🇬' },
  { name: 'Argentina', flag: '🇦🇷' },
  { name: 'Armenia', flag: '🇦🇲' },
  { name: 'Australia', flag: '🇦🇺' },
  { name: 'Austria', flag: '🇦🇹' },
  { name: 'Azerbaijan', flag: '🇦🇿' },
  { name: 'Bahamas', flag: '🇧🇸' },
  { name: 'Bahrain', flag: '🇧🇭' },
  { name: 'Bangladesh', flag: '🇧🇩' },
  { name: 'Barbados', flag: '🇧🇧' },
  { name: 'Belarus', flag: '🇧🇾' },
  { name: 'Belgium', flag: '🇧🇪' },
  { name: 'Belize', flag: '🇧🇿' },
  { name: 'Benin', flag: '🇧🇯' },
  { name: 'Bhutan', flag: '🇧🇹' },
  { name: 'Bolivia', flag: '🇧🇴' },
  { name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { name: 'Botswana', flag: '🇧🇼' },
  { name: 'Brazil', flag: '🇧🇷' },
  { name: 'Brunei', flag: '🇧🇳' },
  { name: 'Bulgaria', flag: '🇧🇬' },
  { name: 'Burkina Faso', flag: '🇧🇫' },
  { name: 'Burundi', flag: '🇧🇮' },
  { name: 'Cabo Verde', flag: '🇨🇻' },
  { name: 'Cambodia', flag: '🇰🇭' },
  { name: 'Cameroon', flag: '🇨🇲' },
  { name: 'Canada', flag: '🇨🇦' },
  { name: 'Central African Republic', flag: '🇨🇫' },
  { name: 'Chad', flag: '🇹🇩' },
  { name: 'Chile', flag: '🇨🇱' },
  { name: 'China', flag: '🇨🇳' },
  { name: 'Colombia', flag: '🇨🇴' },
  { name: 'Comoros', flag: '🇰🇲' },
  { name: 'Congo (Brazzaville)', flag: '🇨🇬' },
  { name: 'Congo (Kinshasa)', flag: '🇨🇩' },
  { name: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Croatia', flag: '🇭🇷' },
  { name: 'Cuba', flag: '🇨🇺' },
  { name: 'Cyprus', flag: '🇨🇾' },
  { name: 'Czech Republic', flag: '🇨🇿' },
  { name: 'Denmark', flag: '🇩🇰' },
  { name: 'Djibouti', flag: '🇩🇯' },
  { name: 'Dominica', flag: '🇩🇲' },
  { name: 'Dominican Republic', flag: '🇩🇴' },
  { name: 'Ecuador', flag: '🇪🇨' },
  { name: 'Egypt', flag: '🇪🇬' },
  { name: 'El Salvador', flag: '🇸🇻' },
  { name: 'Equatorial Guinea', flag: '🇬🇶' },
  { name: 'Eritrea', flag: '🇪🇷' },
  { name: 'Estonia', flag: '🇪🇪' },
  { name: 'Eswatini', flag: '🇸🇿' },
  { name: 'Ethiopia', flag: '🇪🇹' },
  { name: 'Fiji', flag: '🇫🇯' },
  { name: 'Finland', flag: '🇫🇮' },
  { name: 'France', flag: '🇫🇷' },
  { name: 'Gabon', flag: '🇬🇦' },
  { name: 'Gambia', flag: '🇬🇲' },
  { name: 'Georgia', flag: '🇬🇪' },
  { name: 'Germany', flag: '🇩🇪' },
  { name: 'Ghana', flag: '🇬🇭' },
  { name: 'Greece', flag: '🇬🇷' },
  { name: 'Grenada', flag: '🇬🇩' },
  { name: 'Guatemala', flag: '🇬🇹' },
  { name: 'Guinea', flag: '🇬🇳' },
  { name: 'Guinea-Bissau', flag: '🇬🇼' },
  { name: 'Guyana', flag: '🇬🇾' },
  { name: 'Haiti', flag: '🇭🇹' },
  { name: 'Honduras', flag: '🇭🇳' },
  { name: 'Hungary', flag: '🇭🇺' },
  { name: 'Iceland', flag: '🇮🇸' },
  { name: 'India', flag: '🇮🇳' },
  { name: 'Indonesia', flag: '🇮🇩' },
  { name: 'Iran', flag: '🇮🇷' },
  { name: 'Iraq', flag: '🇮🇶' },
  { name: 'Ireland', flag: '🇮🇪' },
  { name: 'Israel', flag: '🇮🇱' },
  { name: 'Italy', flag: '🇮🇹' },
  { name: 'Ivory Coast', flag: '🇨🇮' },
  { name: 'Jamaica', flag: '🇯🇲' },
  { name: 'Japan', flag: '🇯🇵' },
  { name: 'Jordan', flag: '🇯🇴' },
  { name: 'Kazakhstan', flag: '🇰🇿' },
  { name: 'Kenya', flag: '🇰🇪' },
  { name: 'Kiribati', flag: '🇰🇮' },
  { name: 'Kosovo', flag: '🇽🇰' },
  { name: 'Kuwait', flag: '🇰🇼' },
  { name: 'Kyrgyzstan', flag: '🇰🇬' },
  { name: 'Laos', flag: '🇱🇦' },
  { name: 'Latvia', flag: '🇱🇻' },
  { name: 'Lebanon', flag: '🇱🇧' },
  { name: 'Lesotho', flag: '🇱🇸' },
  { name: 'Liberia', flag: '🇱🇷' },
  { name: 'Libya', flag: '🇱🇾' },
  { name: 'Liechtenstein', flag: '🇱🇮' },
  { name: 'Lithuania', flag: '🇱🇹' },
  { name: 'Luxembourg', flag: '🇱🇺' },
  { name: 'Madagascar', flag: '🇲🇬' },
  { name: 'Malawi', flag: '🇲🇼' },
  { name: 'Malaysia', flag: '🇲🇾' },
  { name: 'Maldives', flag: '🇲🇻' },
  { name: 'Mali', flag: '🇲🇱' },
  { name: 'Malta', flag: '🇲🇹' },
  { name: 'Marshall Islands', flag: '🇲🇭' },
  { name: 'Mauritania', flag: '🇲🇷' },
  { name: 'Mauritius', flag: '🇲🇺' },
  { name: 'Mexico', flag: '🇲🇽' },
  { name: 'Micronesia', flag: '🇫🇲' },
  { name: 'Moldova', flag: '🇲🇩' },
  { name: 'Monaco', flag: '🇲🇨' },
  { name: 'Mongolia', flag: '🇲🇳' },
  { name: 'Montenegro', flag: '🇲🇪' },
  { name: 'Morocco', flag: '🇲🇦' },
  { name: 'Mozambique', flag: '🇲🇿' },
  { name: 'Myanmar', flag: '🇲🇲' },
  { name: 'Namibia', flag: '🇳🇦' },
  { name: 'Nauru', flag: '🇳🇷' },
  { name: 'Nepal', flag: '🇳🇵' },
  { name: 'Netherlands', flag: '🇳🇱' },
  { name: 'New Zealand', flag: '🇳🇿' },
  { name: 'Nicaragua', flag: '🇳🇮' },
  { name: 'Niger', flag: '🇳🇪' },
  { name: 'Nigeria', flag: '🇳🇬' },
  { name: 'North Korea', flag: '🇰🇵' },
  { name: 'North Macedonia', flag: '🇲🇰' },
  { name: 'Norway', flag: '🇳🇴' },
  { name: 'Oman', flag: '🇴🇲' },
  { name: 'Pakistan', flag: '🇵🇰' },
  { name: 'Palau', flag: '🇵🇼' },
  { name: 'Palestine', flag: '🇵🇸' },
  { name: 'Panama', flag: '🇵🇦' },
  { name: 'Papua New Guinea', flag: '🇵🇬' },
  { name: 'Paraguay', flag: '🇵🇾' },
  { name: 'Peru', flag: '🇵🇪' },
  { name: 'Philippines', flag: '🇵🇭' },
  { name: 'Poland', flag: '🇵🇱' },
  { name: 'Portugal', flag: '🇵🇹' },
  { name: 'Qatar', flag: '🇶🇦' },
  { name: 'Romania', flag: '🇷🇴' },
  { name: 'Russia', flag: '🇷🇺' },
  { name: 'Rwanda', flag: '🇷🇼' },
  { name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
  { name: 'Saint Lucia', flag: '🇱🇨' },
  { name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { name: 'Samoa', flag: '🇼🇸' },
  { name: 'San Marino', flag: '🇸🇲' },
  { name: 'São Tomé and Príncipe', flag: '🇸🇹' },
  { name: 'Saudi Arabia', flag: '🇸🇦' },
  { name: 'Senegal', flag: '🇸🇳' },
  { name: 'Serbia', flag: '🇷🇸' },
  { name: 'Seychelles', flag: '🇸🇨' },
  { name: 'Sierra Leone', flag: '🇸🇱' },
  { name: 'Singapore', flag: '🇸🇬' },
  { name: 'Slovakia', flag: '🇸🇰' },
  { name: 'Slovenia', flag: '🇸🇮' },
  { name: 'Solomon Islands', flag: '🇸🇧' },
  { name: 'Somalia', flag: '🇸🇴' },
  { name: 'South Africa', flag: '🇿🇦' },
  { name: 'South Korea', flag: '🇰🇷' },
  { name: 'South Sudan', flag: '🇸🇸' },
  { name: 'Spain', flag: '🇪🇸' },
  { name: 'Sri Lanka', flag: '🇱🇰' },
  { name: 'Sudan', flag: '🇸🇩' },
  { name: 'Suriname', flag: '🇸🇷' },
  { name: 'Sweden', flag: '🇸🇪' },
  { name: 'Switzerland', flag: '🇨🇭' },
  { name: 'Syria', flag: '🇸🇾' },
  { name: 'Taiwan', flag: '🇹🇼' },
  { name: 'Tajikistan', flag: '🇹🇯' },
  { name: 'Tanzania', flag: '🇹🇿' },
  { name: 'Thailand', flag: '🇹🇭' },
  { name: 'Timor-Leste', flag: '🇹🇱' },
  { name: 'Togo', flag: '🇹🇬' },
  { name: 'Tonga', flag: '🇹🇴' },
  { name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { name: 'Tunisia', flag: '🇹🇳' },
  { name: 'Turkey', flag: '🇹🇷' },
  { name: 'Turkmenistan', flag: '🇹🇲' },
  { name: 'Tuvalu', flag: '🇹🇻' },
  { name: 'Uganda', flag: '🇺🇬' },
  { name: 'Ukraine', flag: '🇺🇦' },
  { name: 'United Arab Emirates', flag: '🇦🇪' },
  { name: 'United Kingdom', flag: '🇬🇧' },
  { name: 'United States', flag: '🇺🇸' },
  { name: 'Uruguay', flag: '🇺🇾' },
  { name: 'Uzbekistan', flag: '🇺🇿' },
  { name: 'Vanuatu', flag: '🇻🇺' },
  { name: 'Vatican City', flag: '🇻🇦' },
  { name: 'Venezuela', flag: '🇻🇪' },
  { name: 'Vietnam', flag: '🇻🇳' },
  { name: 'Yemen', flag: '🇾🇪' },
  { name: 'Zambia', flag: '🇿🇲' },
  { name: 'Zimbabwe', flag: '🇿🇼' },
];

type SubmitMode = 'screenshot' | 'text';

export default function SubmitPage() {
  const [mode, setMode] = useState<SubmitMode>('text');
  const [roastText, setRoastText] = useState('');
  const [category, setCategory] = useState('');
  const [country, setCountry] = useState('');
  const [context, setContext] = useState('');
  const [dragOver, setDragOver] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(5);
  const fileRef = useRef<HTMLInputElement>(null);
  const { t } = useLanguage();

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files[0];
    if (f && f.type.startsWith('image/')) setFile(f);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) setFile(f);
  };

  const canSubmit = agreed && category && country && (mode === 'text' ? roastText.trim().length > 10 : file !== null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit || loading) return;
    setLoading(true);
    setSubmitError(null);

    const result = await submissionService.submitRoast({
      mode,
      roastText: mode === 'text' ? roastText : undefined,
      screenshotFile: mode === 'screenshot' ? (file ?? undefined) : undefined,
      category,
      country,
      context: context.trim() || undefined,
    });

    setLoading(false);

    if (result.success) {
      setSubmitted(true);
      setCountdown(5);
    } else {
      setSubmitError(result.error || 'Something went wrong. Please try again.');
    }
  };

  const resetForm = () => {
    setSubmitted(false);
    setRoastText('');
    setFile(null);
    setCategory('');
    setCountry('');
    setContext('');
    setAgreed(false);
    setSubmitError(null);
    setCountdown(5);
  };

  useEffect(() => {
    if (!submitted) return;
    if (countdown <= 0) {
      resetForm();
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [submitted, countdown]);

  if (submitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4" style={{ background: 'var(--background)' }}>
        <div className="text-center max-w-md">
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: 'rgba(34,197,94,0.15)', border: '2px solid rgba(34,197,94,0.3)' }}>
            <CheckCircle size={40} style={{ color: 'var(--primary)' }} />
          </div>
          <h1 className="text-3xl font-bold mb-3" style={{ color: 'var(--foreground)' }}>{t('sub_success_title')}</h1>
          <p className="mb-2" style={{ color: 'var(--muted-foreground)' }}>{t('sub_success_desc')}</p>
          <p className="text-sm mb-4" style={{ color: 'var(--muted-foreground)' }}>{t('sub_success_review')}</p>
          <p className="text-sm mb-8 font-medium" style={{ color: 'var(--primary)' }}>
            Returning to form in {countdown}s…
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link href="/roastrank" className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-bold text-sm transition-all duration-200 hover:scale-105"
              style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)', color: '#fff' }}>
              <Flame size={16} />
              {t('sub_back_home')}
            </Link>
            <button onClick={resetForm}
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-bold text-sm transition-all duration-200 hover:bg-white/5"
              style={{ background: 'var(--card)', color: 'var(--foreground)', border: '1px solid var(--border)' }}>
              {t('sub_submit_another')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-24 md:pb-8" style={{ background: 'var(--background)' }}>
      {/* Navbar */}
      <header className="sticky top-0 z-50 w-full" style={{ background: 'rgba(10,10,15,0.92)', backdropFilter: 'blur(20px)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link href="/roastrank" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)' }}>
                <Flame size={18} className="text-white" />
              </div>
              <span className="font-bold text-lg" style={{ color: 'var(--foreground)' }}>Roast<span style={{ color: 'var(--primary)' }}>Rank</span></span>
            </Link>
            <nav className="hidden md:flex items-center gap-1">
              {[
                { label: t('rr_home'), href: '/roastrank' },
                { label: t('rr_leaderboard'), href: '/roastrank/leaderboard' },
                { label: t('rr_browse'), href: '/roastrank/browse' },
                { label: t('rr_submit'), href: '/roastrank/submit' },
              ].map(item => (
                <Link key={item.href} href={item.href} className="px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-white/5"
                  style={{ color: item.href === '/roastrank/submit' ? 'var(--primary)' : 'var(--muted-foreground)' }}>
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)' }}>
            <Flame size={28} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--foreground)' }}>{t('sub_title')}</h1>
          <p style={{ color: 'var(--muted-foreground)' }}>{t('sub_desc')}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Mode Toggle */}
          <div>
            <label className="block text-sm font-semibold mb-3" style={{ color: 'var(--foreground)' }}>{t('sub_how')}</label>
            <div className="grid grid-cols-2 gap-3">
              <button type="button" onClick={() => setMode('text')}
                className="flex items-center gap-3 p-4 rounded-xl transition-all duration-200 text-left"
                style={{
                  background: mode === 'text' ? 'rgba(34,197,94,0.1)' : 'var(--card)',
                  border: mode === 'text' ? '2px solid rgba(34,197,94,0.4)' : '2px solid var(--border)',
                  color: mode === 'text' ? 'var(--primary)' : 'var(--muted-foreground)',
                }}>
                <Type size={20} />
                <div>
                  <div className="font-bold text-sm">{t('sub_type')}</div>
                  <div className="text-xs opacity-70">{t('sub_type_desc')}</div>
                </div>
              </button>
              <button type="button" onClick={() => setMode('screenshot')}
                className="flex items-center gap-3 p-4 rounded-xl transition-all duration-200 text-left"
                style={{
                  background: mode === 'screenshot' ? 'rgba(34,197,94,0.1)' : 'var(--card)',
                  border: mode === 'screenshot' ? '2px solid rgba(34,197,94,0.4)' : '2px solid var(--border)',
                  color: mode === 'screenshot' ? 'var(--primary)' : 'var(--muted-foreground)',
                }}>
                <Image size={20} />
                <div>
                  <div className="font-bold text-sm">{t('sub_screenshot')}</div>
                  <div className="text-xs opacity-70">{t('sub_screenshot_desc')}</div>
                </div>
              </button>
            </div>
          </div>

          {/* Text Input */}
          {mode === 'text' && (
            <div>
              <label className="flex items-center gap-2 text-sm font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
                <Type size={14} />
                {t('sub_roast_label')} <span style={{ color: 'var(--danger)' }}>*</span>
              </label>
              <textarea
                value={roastText}
                onChange={e => setRoastText(e.target.value)}
                placeholder={t('sub_roast_placeholder')}
                rows={5}
                maxLength={500}
                className="w-full px-4 py-3 rounded-xl text-sm outline-none resize-none transition-all duration-200"
                style={{ background: 'var(--card)', border: '1px solid var(--border)', color: 'var(--foreground)' }}
              />
              <div className="flex justify-between mt-1">
                <span className="text-xs" style={{ color: roastText.length < 10 ? 'var(--danger)' : 'var(--muted-foreground)' }}>
                  {roastText.length < 10 ? t('sub_chars_needed').replace('{n}', String(10 - roastText.length)) : t('sub_good_length')}
                </span>
                <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{roastText.length}/500</span>
              </div>
            </div>
          )}

          {/* Screenshot Upload */}
          {mode === 'screenshot' && (
            <div>
              <label className="flex items-center gap-2 text-sm font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
                <Upload size={14} />
                {t('sub_upload_label')} <span style={{ color: 'var(--danger)' }}>*</span>
              </label>
              <div
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={handleDrop}
                onClick={() => fileRef.current?.click()}
                className="relative flex flex-col items-center justify-center gap-3 p-8 rounded-xl cursor-pointer transition-all duration-200"
                style={{
                  background: dragOver ? 'rgba(34,197,94,0.08)' : 'var(--card)',
                  border: dragOver ? '2px dashed rgba(34,197,94,0.5)' : file ? '2px solid rgba(34,197,94,0.4)' : '2px dashed var(--border)',
                }}>
                {file ? (
                  <>
                    <CheckCircle size={32} style={{ color: 'var(--primary)' }} />
                    <div className="text-center">
                      <div className="font-semibold text-sm" style={{ color: 'var(--foreground)' }}>{file.name}</div>
                      <div className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>{(file.size / 1024).toFixed(1)} KB</div>
                    </div>
                    <button type="button" onClick={e => { e.stopPropagation(); setFile(null); }}
                      className="absolute top-3 right-3 p-1 rounded-lg hover:bg-white/10 transition-colors"
                      style={{ color: 'var(--muted-foreground)' }}>
                      <X size={14} />
                    </button>
                  </>
                ) : (
                  <>
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: 'rgba(34,197,94,0.1)' }}>
                      <Upload size={24} style={{ color: 'var(--primary)' }} />
                    </div>
                    <div className="text-center">
                      <div className="font-semibold text-sm" style={{ color: 'var(--foreground)' }}>{t('sub_drop_here')}</div>
                      <div className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>{t('sub_file_types')}</div>
                    </div>
                  </>
                )}
                <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handleFileChange} />
              </div>
            </div>
          )}

          {/* Category */}
          <div>
            <label className="flex items-center gap-2 text-sm font-semibold mb-3" style={{ color: 'var(--foreground)' }}>
              <Tag size={14} />
              Category <span style={{ color: 'var(--danger)' }}>*</span>
            </label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {CATEGORIES.map(cat => (
                <button key={cat.id} type="button" onClick={() => setCategory(cat.id)}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 text-left"
                  style={{
                    background: category === cat.id ? `${cat.color}18` : 'var(--card)',
                    border: category === cat.id ? `1px solid ${cat.color}50` : '1px solid var(--border)',
                    color: category === cat.id ? cat.color : 'var(--muted-foreground)',
                  }}>
                  <span>{cat.icon}</span>
                  <span className="truncate text-xs">{cat.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Country */}
          <div>
            <label className="flex items-center gap-2 text-sm font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
              <Globe size={14} />
              Your Country <span style={{ color: 'var(--danger)' }}>*</span>
            </label>
            <select
              value={country}
              onChange={e => setCountry(e.target.value)}
              className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-all duration-200 appearance-none"
              style={{ background: 'var(--card)', border: '1px solid var(--border)', color: country ? 'var(--foreground)' : 'var(--muted-foreground)' }}>
              <option value="" disabled>Select your country...</option>
              {COUNTRIES.map(c => <option key={c.name} value={c.name} style={{ background: 'var(--card)', color: 'var(--foreground)' }}>{c.flag} {c.name}</option>)}
            </select>
          </div>

          {/* Optional Context */}
          <div>
            <label className="flex items-center gap-2 text-sm font-semibold mb-2" style={{ color: 'var(--foreground)' }}>
              <FileText size={14} />
              Context <span className="text-xs font-normal" style={{ color: 'var(--muted-foreground)' }}>(optional)</span>
            </label>
            <textarea
              value={context}
              onChange={e => setContext(e.target.value)}
              placeholder="Add some context to make the roast funnier... (e.g. 'This was sent at 3am after he said he was sleeping')"
              rows={3}
              maxLength={200}
              className="w-full px-4 py-3 rounded-xl text-sm outline-none resize-none transition-all duration-200"
              style={{ background: 'var(--card)', border: '1px solid var(--border)', color: 'var(--foreground)' }}
            />
          </div>

          {/* Privacy Agreement */}
          <div className="flex items-start gap-3 p-4 rounded-xl" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
            <button type="button" onClick={() => setAgreed(!agreed)}
              className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-200"
              style={{ background: agreed ? 'var(--primary)' : 'transparent', border: agreed ? 'none' : '2px solid var(--border)' }}>
              {agreed && <CheckCircle size={14} className="text-white" />}
            </button>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              I confirm that I have removed all private information (phone numbers, real names, profile pictures) from any screenshot, and I agree to the{' '}
              <span style={{ color: 'var(--primary)', cursor: 'pointer' }}>community guidelines</span>.
            </p>
          </div>

          {/* Error Message */}
          {submitError && (
            <div className="px-4 py-3 rounded-xl text-sm" style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#ef4444' }}>
              {submitError}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!canSubmit || loading}
            className="w-full flex items-center justify-center gap-3 py-4 rounded-2xl font-bold text-base transition-all duration-300"
            style={{
              background: canSubmit && !loading ? 'linear-gradient(135deg, #16a34a, #22c55e)' : 'var(--muted)',
              color: canSubmit && !loading ? '#fff' : 'var(--muted-foreground)',
              cursor: canSubmit && !loading ? 'pointer' : 'not-allowed',
              boxShadow: canSubmit && !loading ? '0 0 30px rgba(34,197,94,0.3)' : 'none',
            }}>
            {loading ? <Loader2 size={20} className="animate-spin" /> : <Flame size={20} />}
            {loading ? 'Submitting...' : 'Submit Your Roast'}
          </button>

          {!canSubmit && !loading && (
            <p className="text-center text-xs" style={{ color: 'var(--muted-foreground)' }}>
              {!agreed ? 'Please agree to the privacy terms' : !category ? 'Select a category' : !country ? 'Select your country' : 'Add your roast content'}
            </p>
          )}
        </form>
      </div>

      {/* Mobile Bottom Nav */}
      <nav className="fixed bottom-0 left-0 right-0 md:hidden z-50" style={{ background: 'rgba(10,10,15,0.95)', backdropFilter: 'blur(20px)', borderTop: '1px solid var(--border)' }}>
        <div className="flex items-center justify-around py-2">
          {[
            { label: 'Home', href: '/roastrank', icon: '🏠' },
            { label: 'Rankings', href: '/roastrank/leaderboard', icon: '🏆' },
            { label: 'Submit', href: '/roastrank/submit', icon: '🔥' },
          ].map(item => (
            <Link key={item.href} href={item.href} className="flex flex-col items-center gap-1 px-4 py-2 rounded-xl transition-all duration-200">
              <span className="text-xl">{item.icon}</span>
              <span className="text-xs font-semibold" style={{ color: item.href === '/roastrank/submit' ? 'var(--primary)' : 'var(--muted-foreground)' }}>{item.label}</span>
            </Link>
          ))}
        </div>
      </nav>
    </div>
  );
}
